import GalleryImage from "./GalleryImage";
import GalleryImagePreview from "./GalleryImagePreview";

export default GalleryImage;
export { GalleryImagePreview };
